import moment from 'moment';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from "primereact/inputtextarea";
import { Knob } from 'primereact/knob';
import { Messages } from 'primereact/messages';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import count_days from '../../functions/count_days';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import { _endPoints, baseUrl, sethandelbooking } from '../../Helper/links';
import pattern from '../../Helper/pattern';
import API from '../../Helper/server/API';
import { useWhatsapp } from '../../whatsapp/WhatsappContext';
import { InvoiceContext } from '../invoice/Invoice_Context';
import InvoiceCustomer from '../invoice/invoice_customer';
import PaidInvoice from '../payments/pay_reservation';

function BookingConfirmStep({ bookingApartmentData, setbookingApartmentData, bookingCustomerData, setbookingCustomerData }) {
    const toast = useRef(null);
    const msgs = useRef(null);
    const opUpdateRefs = useRef({});
    const { SendWhatsAppMsg } = useWhatsapp();
    const [reservations, set_reservations] = useState([])
    const [ViewPaid, setViewPaid] = useState(false);
    const [dataPaid, setDataPaid] = useState(null);
    const [InvoicePaid, setInvoicePaid] = useState(false);
    const [loding, set_loding] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [apartmentData, set_apartmentData] = useState([]);
    const [customerData, setcustomerData] = useState(bookingCustomerData);
    var monthView = 0;
    const [loading_handel, set_loading_handel] = useState(true);
    const items = Array.from({ length: 5 }, (v, i) => i);
    const HandelApartmentBooking = async () => {
        set_loading_handel(true)
        if (bookingApartmentData.length > 0) {
            var datesArr = [];
            // eslint-disable-next-line array-callback-return
            bookingApartmentData?.map((item) => {
                datesArr.push({
                    ...item,
                    dates: item?.dates?.map(index => {
                        return moment(index).format("YYYY-MM-DD");
                    })
                })
            })
            const response = await API.post(sethandelbooking, { apartments: datesArr })
            if (response && response?.success && response?.success === 1) {
                // const rowKey = 0; // use a stable unique id (NOT array index)
                response?.data?.map((item, key) => {
                    if (!opUpdateRefs.current[key]) {
                        opUpdateRefs.current[key] = React.createRef();
                    }
                })
                set_apartmentData(response.data)
            }
            else {
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
            }
            set_loading_handel(false)
        }
        set_loading_handel(false)

    }
    const handel_discount_value = useCallback((value, item) => {
        set_apartmentData(prevData =>
            prevData.map(index => {
                if (
                    index.ID_apartment === item.ID_apartment
                    &&
                    index.date_check_in === item.date_check_in
                ) {
                    if (
                        value !== '' && value !== null
                        && pattern.number_int.test(value) === true
                        && value <= (index.price * count_days([{ date_check_in: index.date_check_in, date_check_out: index.date_check_out }]))
                    ) {
                        return { ...index, discount_value: value };
                    }
                    else {
                        return { ...index, discount_value: 0 };
                    }
                }
                else {
                    return index;
                }
            })
        );
    }, [set_apartmentData]);
    const handel_notes = useCallback((value, item) => {
        set_apartmentData(prevData =>
            prevData.map(index => {
                if (
                    index.ID_apartment === item.ID_apartment
                    &&
                    index.date_check_in === item.date_check_in
                ) {
                    if (
                        value
                        &&
                        value.length <= 1000
                    ) {
                        return { ...index, notes: value };
                    }
                    else {
                        return { ...index, notes: null };
                    }
                }
                else {
                    return index;
                }
            })
        );
    }, [set_apartmentData]);
    const handel_date_del_reservation = useCallback((value, item) => {
        set_apartmentData(prevData =>
            prevData.map(index => {
                if (
                    index.ID_apartment === item.ID_apartment
                    &&
                    index.date_check_in === item.date_check_in
                ) {
                    if (index.date_del_reservation)
                        return { ...index, date_del_reservation: false };
                    else
                        return { ...index, date_del_reservation: true };
                }
                else {
                    return index;
                }
            })
        );
    }, [set_apartmentData]);
    const handel_date_del_reservation_hours = useCallback((value, item, state) => {
        set_apartmentData(prevData =>
            prevData.map(index => {
                if (
                    index.ID_reservation === item.ID_reservation
                    && index.date_del_reservation_new.hours >= 0 && index.date_del_reservation_new.hours <= 120
                ) {
                    if (state === '+' && index.date_del_reservation_new.hours < index.date_del_reservation_new.max_hours) {
                        return {
                            ...index, date_del_reservation_new: {
                                hours: index.date_del_reservation_new.hours + 1,
                                max_hours: index.date_del_reservation_new.max_hours,
                            }
                        };
                    }
                    else if (state === '-' && index.date_del_reservation_new.hours > 1) {
                        return {
                            ...index, date_del_reservation_new: {
                                hours: index.date_del_reservation_new.hours - 1,
                                max_hours: index.date_del_reservation_new.max_hours,
                            }
                        };
                    }
                    else {
                        return index;
                    }
                }
                else {
                    return index;
                }
            })
        );
    }, [set_apartmentData]);
    const handel_date_del_reservation_days = useCallback((value, item, state) => {
        set_apartmentData(prevData =>
            prevData.map(index => {
                if (
                    index.ID_reservation === item.ID_reservation
                    && index.date_del_reservation_new.days <= index.date_del_reservation_new.max_days
                ) {

                    if (state === '-' && index.date_del_reservation_new.days > 0) {
                        return {
                            ...index, date_del_reservation_new: {
                                days: index.date_del_reservation_new.days - 1,
                                max_days: index.date_del_reservation_new.max_days,
                                hours: index.date_del_reservation_new.hours,
                                max_hours: index.date_del_reservation_new.max_hours
                            }
                        };
                    }
                    else if (state === '+' && index.date_del_reservation_new.days < index.date_del_reservation_new.max_days) {
                        return {
                            ...index, date_del_reservation_new: {
                                days: index.date_del_reservation_new.days + 1,
                                max_days: index.date_del_reservation_new.max_days,
                                hours: index.date_del_reservation_new.hours,
                                max_hours: index.date_del_reservation_new.max_hours
                            }
                        };
                    }
                    else {
                        return index;
                    }
                }
                else {
                    return index;
                }
            })

        );
    }, [set_apartmentData]);
    const remove_item = async (e, item) => {
        bookingApartmentData?.forEach((apartment) => {
            if (apartment.id_apartment === item.ID_apartment) {
                apartment.dates = apartment.dates?.filter((date) => {
                    // Remove the date if it matches the condition
                    return !(moment(date).format("YYYY-MM-DD") >= moment(item.date_check_in).format("YYYY-MM-DD") && moment(date).format("YYYY-MM-DD") < moment(item.date_check_out).format("YYYY-MM-DD"));
                });
            }
        });
        set_apartmentData(
            apartmentData.filter(a => a !== item)
        );

    }
    const remove_all_item = async (e) => {
        setbookingApartmentData([])
        set_apartmentData([]);
    }
    const total_price = (item) => {
        var total = 0;
        // eslint-disable-next-line array-callback-return
        item?.map(index => {
            total += (index.price * count_days([{ date_check_in: index.date_check_in, date_check_out: index.date_check_out }])) - index.discount_value;
        })
        return total
    }
    const SetBooking = async (e) => {
        set_loding(true)
        if (!customerData.ID_customer || pattern.number_int.test(customerData?.ID_customer) === false) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو أختيــار العميــل'
            });
        }
        else if (!apartmentData.length > 0) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو  نــوع الإقــامة'
            });
        }
        else {
            var data = {
                id_customer: customerData?.ID_customer ? customerData.ID_customer : null,
                booking: apartmentData
            }
            const response = await API.post(_endPoints.reservations.add, data)
            if (response?.success === 1) {

                set_apartmentData([])
                setbookingApartmentData([])
                setcustomerData(null)
                setbookingCustomerData(null)
                set_reservations(response.data)
                setViewPaid(true)
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'success', summary: 'نجــاح', detail: response?.msg
                });
                if (response?.errors) {
                    toast.current.show({
                        style: {
                            fontFamily: "Cairo",
                            fontSize: "1.2rem"
                        },
                        life: 5000,
                        severity: 'error', summary: 'خطــاء', detail: ''
                    });
                }
                SendWhatsAppMsg(_endPoints.whatsapp.new_booking, {
                    ID_customer: customerData?.ID_customer,
                    status_booking: "new"
                })

            }
            else if (response?.success === 0) {
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.errors) {
                    if (response?.booking)
                        set_apartmentData(response.booking)
                }
            }
        }
        set_loding(false)
    }
    useEffect(() => {
        HandelApartmentBooking();
        if (!customerData?.ID_customer) {
            msgs.current.show([
                {
                    severity: 'error', detail: '', summary: "يرجى اختيار العميل لإتمام عملية الحجز.", sticky: true, closable: false, style: {
                        padding: "1rem"
                    }
                }
            ]);
        }
        else if (customerData?.state === 0) {
            msgs.current.show([
                {
                    severity: 'error', detail: '', summary: "العميــل فــي قائمــة الحظــر.", sticky: true, closable: false, style: {
                        padding: "1rem"
                    }
                }
            ]);
        }



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [value, setValue] = useState(0);
    const view_test = (value) => {
        return <h1>test</h1>
    }

    return (
        <div>
            <div class="ibox">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="ibox invoice-print" >
                    <div className="invoice-header">
                        <div>
                            <div className="col-md-12">
                                <div className="row font-15">
                                    <div className="col-md-6 " style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                        <div className="m-b-5 font-bold mt-4 " >بيـــانات العميـــل</div>
                                        <hr></hr>

                                        <div className="m-b-5 font-bold" >
                                            <i class="ti-user font-26 text-muted ml-2" dir='rtl'></i> {customerData?.visitor_name ? customerData?.visitor_name : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-phone font-26 text-muted ml-3 "></i>
                                            {customerData?.phone_number ?
                                                <>{customerData?.phone_number} <small class=" text-muted" dir='ltr' > +218 </small></>
                                                : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-whatsapp font-26 text-muted ml-3 "></i>
                                            {customerData?.whatsapp_number ?
                                                <>{customerData.whatsapp_number} +</>
                                                : <>-</>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 " style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                        <div className="m-b-5 font-bold mt-4 " >بيانات الحجــوزات</div>
                                        <hr></hr>

                                        <div className="m-b-5 font-bold" >
                                            <span className="font-strong"> عـدد الحجــوزات  السـابـقة : </span>
                                            {customerData?.count_reservationes}
                                        </div>
                                        <div className="m-b-5 font-bold pt-3" >
                                            <span className="font-strong"> عـدد الحجــوزات : </span>
                                            {!loading_handel ? apartmentData.length : null}
                                        </div>
                                        <div className="m-b-5 font-bold pt-3" >
                                            <span className="font-strong"> إجمــالي الأيـــام : </span>
                                            {!loading_handel ? count_days(apartmentData) : null}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        {
                            loading_handel ?
                                <>
                                    <div className="col-md-12" >
                                        <div className="card p-0 m-0" >
                                            <DataTable value={items} className="p-datatable-striped p-0 m-0" style={{ width: '100%' }}>
                                                <Column style={{ width: '25%', height: "60px" }} headerStyle={{ height: "50px" }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='col-md-12'>
                                    <div class="table-responsive">
                                        <table className="table table-bordered table-striped no-margin table-invoice" style={{ width: "100%" }}>
                                            <thead className="color-view bg-ebony" style={{ fontSize: "15px" }}>
                                                <tr style={{ color: "white" }}>
                                                    <th style={{ width: "10%" }}>الاقامة</th>
                                                    <th colSpan={2} style={{ textAlign: "center", width: "25%" }} >
                                                        الدخــول - المغــادرة
                                                    </th>
                                                    <th style={{ width: "5%" }}>المـدة</th>
                                                    <th style={{ width: "10%" }}>سعر اليـوم</th>
                                                    {/* <th style={{width:"10%"}}>الإجمــالي</th> */}
                                                    <th style={{ textAlign: "center", width: "5%" }}> الخصــم</th>
                                                    <th style={{ width: "10%" }}>الإجمــالي</th>
                                                    <th style={{ textAlign: "center", width: "5%" }}>ملاحظات</th>
                                                    <th style={{ textAlign: "center", width: "10%" }}>حالة الحجز</th>

                                                    <th style={{ textAlign: "center", width: "10%" }}>فترة  إلغاء  الحجز</th>
                                                    <th style={{ textAlign: "center", verticalAlign: "center" }}>
                                                        <Button icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" onClick={(e) => remove_all_item(e)} />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: "15px" }} >
                                                {
                                                    // eslint-disable-next-line array-callback-return
                                                    apartmentData?.map((item, key) => {
                                                        return (
                                                            <>
                                                                {/* {
                                                    monthView !== moment(item.check_in).format('MM')?
                                                    (
                                                        <tr>
                                                            <td colSpan={11}>
                                                                <center>
                                                                    <strong >
                                                                    {" حجوزات شهر " }
                                                                        { monthView = moment(item.check_in).format('MM')}
                                                                    {" " + moment(item.check_in).format('MMMM') + " "}
                                                                    </strong>
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    (null)
                                                } */}
                                                                <tr style={item.available === false ? { color: "red" } : null}>
                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                        <div>
                                                                            <small>{view_apartment_type_ar(item.type)}</small><strong>{"-" + item.number}</strong>
                                                                        </div>
                                                                        <small>{item.number_people} أشخاص </small>
                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                        <div>
                                                                            <strong >{item.date_check_in} </strong>
                                                                        </div>
                                                                        <small> {view_day_ar(item.date_check_in)} - {item.time_check_in} </small>
                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                        <div>
                                                                            <strong>{item.date_check_out}  </strong>
                                                                        </div>
                                                                        <small>  {view_day_ar(item.date_check_out)} - {item.time_check_out} </small>

                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle" }}>{item.days} أيام</td>
                                                                    <td style={{ verticalAlign: "middle" }}>{item.price}  د.ل</td>
                                                                    {/* <td style={{verticalAlign:"middle"}}><strong >{(item.price*count_days([{date_check_in:item.date_check_in,date_check_out:item.date_check_out}]))} د.ل</strong></td> */}
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle", }}>
                                                                        <InputNumber value={item.discount_value} onChange={(e) => handel_discount_value(e.value, item)}
                                                                            style={{ fontFamily: "Cairo", maxWidth: "5rem" }}
                                                                            min={0}

                                                                            inputId='discount_value'
                                                                        ></InputNumber>
                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle" }}><strong >{(item.price * count_days([{ date_check_in: item.date_check_in, date_check_out: item.date_check_out }])) - item.discount_value} د.ل</strong></td>
                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                        <InputTextarea maxLength={1000} value={item.notes} onChange={(e) => handel_notes(e.target.value, item)} />
                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                        <Button icon={item.date_del_reservation ? "pi pi-clock  ml-2 " : "pi true-icon pi-check-circle ml-2"} label={item.date_del_reservation ? " مبــدئي" : "مـــؤكد"} outlined
                                                                            severity={item.date_del_reservation ? "danger" : "success"}
                                                                            style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                                                                            onClick={(e) => handel_date_del_reservation(e, item)} />
                                                                    </td>
                                                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                        <span>
                                                                            {item.date_del_reservation ?
                                                                                <>

                                                                                    <Button
                                                                                        label={
                                                                                            <>
                                                                                                {item.date_del_reservation_new.hours} ساعات
                                                                                            </>
                                                                                        }
                                                                                        disabled={item?.change_time_delete == 0 || item?.change_time_delete == false ? true : false}

                                                                                        severity="danger" outlined
                                                                                        style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                                                                                        onClick={(e) => opUpdateRefs.current[key].current?.toggle(e)}
                                                                                    />
                                                                                    <OverlayPanel
                                                                                        ref={opUpdateRefs.current[key]}
                                                                                        dismissable
                                                                                        className="custom-overlaypanel"
                                                                                    >
                                                                                        <>
                                                                                            <center>
                                                                                                <p className='text-xl font-bold m-0 p-0'> إلغاء الحجز بعد  </p>
                                                                                            </center>
                                                                                            <Knob value={item.date_del_reservation_new.hours} size={100} min={1} max={item?.date_del_reservation_new?.max_hours} dir='ltr' valueTemplate={`${item?.date_del_reservation_new?.hours} ســ `} />
                                                                                            <center>ســاعات</center>
                                                                                            <Button icon="pi pi-plus" onClick={(e) => handel_date_del_reservation_hours(e.useCallback, item, '+')} className='mr-2' text />
                                                                                            <Button icon="pi pi-minus" onClick={(e) => handel_date_del_reservation_hours(e.useCallback, item, '-')} disabled={item.date_del_reservation_new.hours === 0} className='mr-4' text />
                                                                                        </>
                                                                                    </OverlayPanel>
                                                                                </> : null
                                                                            }
                                                                        </span>

                                                                    </td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                        <Button icon="pi pi-times" rounded text severity="danger" aria-label="Cancel"
                                                                            onClick={(e) => remove_item(e, item)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <table className="table no-border">
                                        <thead >
                                            <tr>
                                                <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                                                <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                                                <td className="font-bold font-18 text-center">إجمالي المتبقي  </td>
                                            </tr>
                                        </thead>
                                        <tbody  >
                                            <tr>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{!loading_handel ? <>{total_price(apartmentData)} د.ل</> : <>-</>} </td>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>-</td>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px", color: "red" }}>{!loading_handel ? <>{total_price(apartmentData)} د.ل</> : <>-</>} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                        }
                        <div className='col-md-12 p-5'>
                            <center>
                                <Messages ref={msgs} style={{ width: "35vh" }} />
                                <Button label="حجـــــز" raised severity='success' style={{ fontFamily: "Cairo", width: "35vh" }} disabled={loading_handel || !customerData?.ID_customer || customerData?.state === 0 || apartmentData.length === 0 ? true : false}
                                    onClick={SetBooking} loading={loding}
                                />
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            {
                ViewPaid && reservations ?
                    (
                        <>
                            <Dialog dir="rtl" header="إيصال قبض الحجوزات القادمة"
                                maximizable style={{ width: '60vw', fontFamily: "Cairo" }}
                                visible={ViewPaid} onHide={() => setViewPaid(false)} maximized={window.innerWidth <= 1230 ? true : false}
                            >
                                <InvoiceContext.Provider value={
                                    {
                                        customer: reservations?.customer,
                                        "reservations": reservations?.reservations,
                                        "setViewPaid": setViewPaid,
                                        "GetReservationesComing": () => { },
                                        "GetReservationesNow": () => { },
                                        "GetReservationesOld": () => { },
                                        "setSelectedReservationes": () => { },
                                        "setDataPaid": setDataPaid,
                                        "setInvoicePaid": setInvoicePaid,
                                        "toast": toast,
                                    }
                                } >
                                    <PaidInvoice></PaidInvoice>

                                </InvoiceContext.Provider>
                            </Dialog>
                        </>
                    )
                    :
                    (null)
            }
            {
                InvoicePaid ?
                    (
                        <>
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={true} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setInvoicePaid(false)} maximized={window.innerWidth <= 1230 ? true : false} >
                                <InvoiceContext.Provider value={dataPaid} >
                                    {dataPaid && <InvoiceCustomer></InvoiceCustomer>}
                                </InvoiceContext.Provider>
                            </Dialog>
                        </>
                    )
                    :
                    (null)
            }
        </div>
    )
}

export default BookingConfirmStep